export const DocumentationThemes = ["workleap", "sharegate"] as const;
